import { Component, Event, EventEmitter, h, Host, Prop, State, Watch } from '@stencil/core';
import { If } from '@utils/If';
@Component({
  tag: 'phone-input',
  styleUrl: 'phone-input.scss',
  shadow: false
})
export class PhoneInput {
  @State() isFocused: boolean = false;
  @Prop() name: string;
  @Prop() disabled: boolean = false;
  @Prop() label: string;
  @Prop() error: string = '';
  @Prop() value: string;
  @Prop() type: string = 'text';
  @Prop() inputMode: string = 'tel';
  @Prop() maxLength?: number = 10;
  @Prop() readOnly: boolean = false;
  @Prop() loading: boolean = false;
  @Prop() autoFocus: boolean = false;
  @Event() valueChanged: EventEmitter<{ mobile: string; target: HTMLInputElement }>;
  @Event() focused: EventEmitter<void>;
  @Event() blurred: EventEmitter<void>;
  @Event() clickRightIcon: EventEmitter<void>;
  inputEl?: HTMLInputElement;
  @Watch('error')
  watchShowCards() {
    if (typeof document === 'undefined') return;
  }
  @Watch('autoFocus')
  onActiveChange(newValue: boolean) {
    if (newValue) setTimeout(() => this.inputEl?.focus(), 300);
  }

  private handleInput = (e: Event) => {
    const target = e.target as HTMLInputElement;
    this.valueChanged.emit({ mobile: target.value, target });
  };

  onKeypress = (event: any) => {
    const allowedChars = /[0-9]/;
    if (event.key === 'Enter' || event.key === 'Tab') {
      return;
    }
    if (!allowedChars.test(event.key)) {
      event.preventDefault();
    }
  };

  private handleFocus = () => {
    this.focused.emit();
    if (!this.isFocused) this.isFocused = true;
  };

  private handleBlur = () => {
    this.blurred.emit();
    this.isFocused = false;
  };

  componentDidLoad() {
    if (this.autoFocus) setTimeout(() => this.inputEl?.focus(), 300);
  }

  render() {
    return (
      <Host>
        <div class="w-full flex flex-col">
          <div
            class={`border border-solid rounded-[14px] relative flex items-center px-4 py-2.5 transition-all duration-200 ${this.error ? (this.isFocused ? 'border-sb-danger error-focus-color' : 'border-sb-danger') : this.isFocused ? 'border-sb-primary focus-color' : 'border-gray-300'
              }`}
          >
            <div class="flex items-center gap-1 text-black text-base md:text-sm">
              <span class="mr-0.5">🇮🇳</span>
              +91 <span class="text-gray-300 ml-1 text-base md:text-sm">|</span>
            </div>
            <input
              id={this.name}
              ref={el => (this.inputEl = el as HTMLInputElement)}
              name={this.name}
              autocomplete="off"
              type={this.type}
              inputMode={this.inputMode}
              value={this.value}
              maxLength={this.maxLength}
              disabled={this.disabled}
              readOnly={this.readOnly}
              placeholder="no remove"
              onInput={this.handleInput}
              onFocus={this.handleFocus}
              onBlur={this.handleBlur}
              onKeyPress={this.onKeypress}
              class={`w-full text-black border-none tracking-[9px] phone-input text-base sm:text-sm focus:outline-none text-lg/6.5 placeholder-transparent ml-2`}
            />
            <label
              htmlFor={this.name}
              class={`absolute ${this.isFocused ? (this.error ? 'text-sb-danger' : 'text-sb-primary') : 'text-gray-500 text-sm'
                } bg-white px-1 vertical-center left-20 transition-all pointer-events-none`}
            >
              {this.label}
            </label>
          </div>
          <If condition={!!this.error} children={<p class="text-sb-danger mt-1 text-xs">{this.error}</p>} />
        </div>
      </Host>
    );
  }
}
